import type { OperationModelType } from "~/core/models/OperationModelType.enum";

export function getOperationModelTypeLabel(
  operationModelType: OperationModelType,
  te: (key: string) => boolean,
  t: (key: string, ...args: any[]) => string,
) {
  const i18nKey = `campaign.funnel.campaignSettings.operationModelType.${operationModelType}`;
  return te(i18nKey) ? t(i18nKey) : operationModelType;
}
